// DISABLED: All animations removed for instant loading
document.addEventListener('DOMContentLoaded', function() {
  // Immediately show all content without animations
  const mainContent = document.getElementById('MainContent');
  if (mainContent) {
    mainContent.classList.add('loaded');
  }
  
  // Disable all section animations - everything should be visible immediately
  const sections = document.querySelectorAll('.shopify-section');
  sections.forEach(section => {
    // Force all sections to be visible immediately
    section.style.opacity = '1';
    section.style.visibility = 'visible';
    section.style.transform = 'none';
    
    // Remove any animation classes
    section.classList.remove('animate-section', 'section-hidden');
    section.classList.add('section-visible');
  });
});

// Disabled animation initialization
function initializeSectionAnimations() {
  // All animations disabled - no intersection observers needed
  console.log('Section animations disabled for instant loading');
} 